<div class="toggle-container" [class.checked]="checked" (click)="onToggleChange()">
    <div class="toggle-thumb">
        <span class="material-icons" *ngIf="!checked">close</span>
        <!-- "X" icon -->
        <span class="material-icons" *ngIf="checked">search</span>
        <!-- Search icon -->
    </div>
</div>

